import { Component, OnInit } from '@angular/core';
import { PageEvent, MatTableDataSource } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { UtilService } from '@service/util.service';
import { InvitationsService } from '@service/invitations.service';
import { Paginate } from '@model/Paginate';
import { Invitation } from '@model/Invitation';
import { Message } from '@model/Message';
import { ModalRepositoriesComponent } from '@component/modal-repositories/modal-repositories.component';

@Component({
  selector: 'app-invitations',
  templateUrl: './invitations.component.html',
  styleUrls: ['./invitations.component.scss']
})
export class InvitationsComponent implements OnInit {

  public displayedColumns: string[] = ['role', 'project_title', 'project_owner', 'actions'];
  public pageEvent: PageEvent;
  public page: Paginate<Invitation> = {
    page: 20,
    current: 0,
    total: 0
  } as Paginate<Invitation>;
  public dataSource = new MatTableDataSource<any>();
  public pageSizeOptions: number[] = [5, 10, 20];

  private modalOptions: NgbModalOptions;

  constructor(
    private utilService: UtilService,
    private toast: ToastrService,
    private invitationsService: InvitationsService,
    private readonly modalService: NgbModal,
  ) {
    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg'
    };
  }

  ngOnInit() {
    this.pageEvent = this.getInvitations({
      previousPageIndex: 0,
      pageIndex: this.page.current,
      pageSize: this.page.page,
      length: this.page.total
    });
  }

  getInvitations(event?: PageEvent): PageEvent {
    this.invitationsService.paginate(event.pageIndex + 1, event.pageSize)
    .subscribe(
      (pagedData: Paginate<Invitation>) => {
        this.page = {...this.page, total: pagedData.total};
        const rows = new Array<any>();
        pagedData.data.forEach(invitation => {
          rows.push({
            id: invitation.id,
            role: this.utilService.translateRole(invitation.role),
            project_title: invitation.project.title,
            project_owner: invitation.project.owner,
            project_id: invitation.project.id,
          });
        });
        this.dataSource.data = [...rows];
      }
    );
    return event;
  }

  accept(invitation: any): void {
    let modal = this.modalService.open(ModalRepositoriesComponent, this.modalOptions);
    modal.componentInstance.invitation = invitation;
    modal.result.then(() => {
      this.getInvitations(this.pageEvent);
      this.toast.success(Message.SUCCESS);
    });
    // this.invitationsService.accept(idInvitation).subscribe(() => {
    //   this.getInvitations(this.pageEvent);
    //   this.toast.success(Message.SUCCESS);
    // });
  }

  reject(idInvitation: number): void {
    this.invitationsService.reject(idInvitation).subscribe(() => {
      this.getInvitations(this.pageEvent);
      this.toast.success(Message.SUCCESS);
    });
  }
}
